// recordingNotice.ts — CORE-1658
//
// Предупреждение перед входом в Live-сессию: текст и его версия в одном месте,
// общие для веба и приложения. Нажатие «Войти» — это ещё и согласие на
// использование изображения и голоса в составе записи, в том числе для
// продвижения, поэтому подтверждение сохраняется на сервере вместе с версией
// текста, который человек видел.
//
// Основа — формулировка юриста от 07.10.2026 (CORE-1565). Три отличия от неё —
// решения владельца от 11.10.2026: термин «Live-сессия» вместо «Стрим»; «может
// записываться», потому что при ручном режиме мастер запись может и не
// включить; демонстрация экрана названа, потому что она в запись попадает.
//
// Любая правка текста — новая версия: под прежней уже лежат подтверждения.

/** Версия текста — уходит на сервер с каждым подтверждением. */
export const RECORDING_NOTICE_VERSION = '2026-10-11';

export const RECORDING_NOTICE_TITLE = 'Эта Live-сессия может записываться';

export const RECORDING_NOTICE_BODY =
  'В запись могут попасть ваши изображение, голос, демонстрация экрана и сообщения. '
  + 'Запись может быть доступна участникам Live-сессии, а отдельные фрагменты — использоваться '
  + 'для продвижения Платформы, Мастеров, Live-сессий и другого контента, в том числе на Платформе, '
  + 'в социальных сетях и рекламных материалах.\n\n'
  + 'Нажимая «Войти», вы подтверждаете, что ознакомились с информацией о записи и соглашаетесь '
  + 'на использование ваших изображения и голоса в составе записи Live-сессии в указанных целях.';

export const RECORDING_NOTICE_ACCEPT = 'Войти';
export const RECORDING_NOTICE_DECLINE = 'Не входить';
export const RECORDING_NOTICE_SAVE_ERROR = 'Не получилось сохранить подтверждение. Попробуйте ещё раз';

/**
 * Показывать ли предупреждение. Всегда, кроме хоста: записаться может любая
 * сессия (режимов два — автоматически и вручную), а настройка мастера
 * «Предупреждать до входа» больше ничего не решает. Хост запись настраивает сам.
 */
export function needsRecordingNotice(input: { hasRoom: boolean; isHost: boolean; acknowledged: boolean }): boolean {
  return input.hasRoom && !input.isHost && !input.acknowledged;
}
